import { flow } from 'fp-ts/function';
import { get, has, last, split, trim } from 'lodash/fp';

import { container } from '@mews-commander/legacy-app-instance';

const US_COUNTRY_CODE = 'US';
const GB_COUNTRY_CODE = 'GB';

export const mapAzureLocation = (place: $TSFixMe) => ({
    addressLine1: getAddressLine1(place),
    addressLine2: place.municipalitySubdivision,
    city: place.municipality,
    postalCode: getPostalCode(place),
    countryCode: place.country.code,

    countrySubdivisionCode:
        has('country.code', place) && place.countrySubdivision && `${place.country.code}-${place.countrySubdivision}`,
});

export const metasAddressAutocomplete = (place: $TSFixMe, prefix: $TSFixMe) => {
    const address = enterpriseAddressAutocomplete(place);
    const change = changeValue(prefix);

    change('AddressLine1', address.addressLine1);
    change('AddressLine2', address.addressLine2);
    change('City', address.city);
    change('PostalCode', address.postalCode);
    change('PositionLongitude', address.longitude);
    change('PositionLatitude', address.latitude);
    change('Country.Id', address.countryCode);
    change('CountrySubdivision.Id', address.countrySubdivisionCode);
};

export const enterpriseAddressAutocomplete = (place: $TSFixMe) => {
    const { appLocalizationComponent } = container();
    const basicAddress = mapAzureLocation(place);
    const options = { precision: 7 };
    const enterpriseAddress = {
        latitude: appLocalizationComponent.localizeNumber(get('coordinates.latitude', place), options),
        longitude: appLocalizationComponent.localizeNumber(get('coordinates.longitude', place), options),
    };

    return {
        ...basicAddress,
        ...enterpriseAddress,
    };
};

const changeValue = (prefix: $TSFixMe) => (id: $TSFixMe, value: $TSFixMe) =>
    withElement(findElement(id, prefix), (element: $TSFixMe) => {
        element.value = value;
        triggerChange(element);
    });

const withElement = (el: $TSFixMe, callback: $TSFixMe) => {
    if (el) {
        callback(el);
    }

    return el;
};

const findElement = (id: $TSFixMe, prefix: $TSFixMe) => document.getElementsByName(`${prefix}.${id}`)[0];

const triggerChange = (el: $TSFixMe) => {
    const e = new window.Event('change', { bubbles: true });
    el.dispatchEvent(e);
};

const getAddressLine1 = ({ streetName, streetNumber, country: { code } = {} }: $TSFixMe) => {
    const isAvailableFullAddress = streetName && streetNumber;
    if (isAvailableFullAddress) {
        if (code === US_COUNTRY_CODE || code === GB_COUNTRY_CODE) {
            return `${streetNumber} ${streetName}`;
        }
        return `${streetName} ${streetNumber}`;
    }
    return streetName || streetNumber;
};

// @ts-expect-error $TSFxMeError: No overload matches this call.
const getLastPostalCode = flow(split(','), last, trim);
const getPostalCode = ({ postalCode, extendedPostalCode }: $TSFixMe) =>
    getLastPostalCode(extendedPostalCode || postalCode);
